import {
  CHANGE_IS_VALID,
  SET_ON_SUBMIT,
  SET_DIALOG,
  RESET_DIALOG,
} from "common/rdx/feedback/feedback.actions";

export const INITIAL_STATE = {
  dialog: {
    type: null,
    open: false,
    onSubmit: null,
    isValid: false,
    onFormikCallback: null,
  },
};

// eslint-disable-next-line default-param-last
function FormatReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case CHANGE_IS_VALID:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          isValid: payload,
        },
      };
    case SET_ON_SUBMIT:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          onSubmit: payload,
        },
      };
    case SET_DIALOG:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          ...payload,
        },
      };
    case RESET_DIALOG:
      return {
        ...state,
        dialog: INITIAL_STATE.dialog,
      };
    default:
      return state;
  }
}

export default FormatReducer;
